import { EAuthEligibility, eAuthRestrictionResons } from "../../../shared/utilities/Constants";

export class EAuthModelCustomer {
    isAccountWebEnabled: boolean;
    customerId: string;
    isCustomerWebEnrolled: boolean;
    customerWebEnrolled: string;
    emailId: string;
    firstName: string;
    lastName: string;
    loginIdEnrollStatus: string;
    isDisplayAllowed: boolean;
    isCustomerEAuthEligible: boolean;
    organizationName: string;
    eauthInd: boolean;
    typeCode: string;
    customerRestrictionReason: string;
    accountRoles: string[];
    custID?: string;

    constructor(customer: EAuthModelCustomer) {
        this.isAccountWebEnabled = customer.isAccountWebEnabled;
        this.customerId = customer.customerId;
        this.isCustomerWebEnrolled = customer.isCustomerWebEnrolled;
        this.customerWebEnrolled = customer.customerWebEnrolled;
        this.emailId = customer.emailId;
        this.firstName = customer.firstName;
        this.lastName = customer.lastName;
        this.loginIdEnrollStatus = customer.loginIdEnrollStatus;
        this.isDisplayAllowed = customer.isDisplayAllowed;
        this.isCustomerEAuthEligible = customer.isCustomerEAuthEligible;
        this.organizationName = customer.organizationName;
        this.eauthInd = customer.eauthInd;
        this.typeCode = customer.typeCode;
        this.customerRestrictionReason = customer.customerRestrictionReason;
        this.accountRoles = customer.accountRoles;
        this.custID = customer.custID;
    }

    set eligibility(val: EAuthEligibility) {
        this.eligibility = val;
    }

    get eligibility(): EAuthEligibility {
        if (this.isCustomerEAuthEligible) {
            return 'Complete';
        } else if (this.customerRestrictionReason === eAuthRestrictionResons.noEmailOnRecord) {
            return 'Email required';
        }
        return 'Ineligible';
    }
}
